import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import { AppstoreOutlined, FireOutlined, ThunderboltOutlined } from '@ant-design/icons';
import HeatCompanyFinancials from './financials/HeatCompanyFinancials';
import ElectricityCompanyFinancials from './financials/ElectricityCompanyFinancials';
import CombinedCompanyFinancials from './financials/CombinedCompanyFinancials';
import { splitFinancialData } from '../utils/financialSplitter';
import { COLORS } from '../constants/theme';

/**
 * Financial Dashboard Component
 * Displays all financial metrics with proper OPEX/CAPEX separation
 */
const FinancialDashboard = ({ stats = {}, config = {} }) => {
  // Calculate financial split for heat and electricity companies
  const financialSplit = useMemo(() => {
    return splitFinancialData(stats, config);
  }, [stats, config]);

  // Define tab items
  const tabItems = [
    {
      key: 'overview',
      label: (
        <span>
          <AppstoreOutlined /> Overblik
        </span>
      ),
      children: <CombinedCompanyFinancials financialData={financialSplit} stats={stats} config={config} />,
    },
    {
      key: 'heat',
      label: (
        <span>
          <FireOutlined /> Varme
        </span>
      ),
      children: <HeatCompanyFinancials financialData={financialSplit} />,
    },
    {
      key: 'electricity',
      label: (
        <span>
          <ThunderboltOutlined /> El
        </span>
      ),
      children: <ElectricityCompanyFinancials financialData={financialSplit} />,
    },
  ];

  return (
    <div style={{ marginTop: '2rem' }}>
      <h2 style={{
        color: COLORS.ui.text.primary,
        marginBottom: '1rem',
        fontSize: '1.5rem',
      }}>
        Finansielt Dashboard
      </h2>

      <Tabs
        defaultActiveKey="overview"
        items={tabItems}
        size="large"
      />
    </div>
  );
};

export default FinancialDashboard;
